<template>
  <section class="why">
    <div class="why__glow why__glow--orange" aria-hidden="true"></div>
    <div class="why__glow why__glow--blue" aria-hidden="true"></div>
    <div class="why__dots" aria-hidden="true"></div>

    <div class="why__container">
      <div class="why__head reveal">
        <p class="why__eyebrow">Assuraf</p>
        <h2 class="why__title">{{ $t('home_page.pourquoi_assuraf') }}</h2>
        <span class="why__bar"></span>
        <p class="why__intro">{{ $t('home_page.texte_intro') }}</p>
      </div>

      <div class="why__grid">
        <article class="why__card reveal" v-for="(step, i) in steps" :key="i">
          <span class="why__num" aria-hidden="true">{{ step.num }}</span>
          <span class="why__icon" :class="'why__icon--' + ((i % 2) + 1)">
            <i class="material-icons">{{ step.icon }}</i>
          </span>
          <div class="why__text">
            <p v-for="(line, j) in step.title" :key="j">{{ line }}</p>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'pourquoi_section',
  data: () => ({
    title: 'Assuraf',
    description: 'Le meilleur de l\'assurance en ligne au Sénégal. Faites votre devis, souscrivez et payez en ligne: vous êtes assuré ! Un service simple, une offre claire et complète, une expérience proactive et multicanale.'
  }),
  computed: {
    steps() {
      const t = key => this.$t(key);
      return [
        { num: '01', icon: 'store', title: t('home_page.un') },
        { num: '02', icon: 'bolt', title: t('home_page.deux') },
        { num: '03', icon: 'credit_card', title: [t('home_page.trois')] },
        { num: '04', icon: 'verified_user', title: t('home_page.quatre') }
      ];
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [{
        charset: 'utf-8'
      },
        {
          name: 'description',
          content: this.description
        }
      ]
    }
  },

  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>

<style lang="less" scoped>

@import "../../../assets/less/config";

.why {
  position: relative;
  overflow: hidden;
  padding: 96px 24px;
  background: linear-gradient(180deg, #fff 0%, #FFFBF6 100%);

  &__glow {
    position: absolute;
    border-radius: 50%;
    filter: blur(90px);
    opacity: 0.4;
    pointer-events: none;

    &--orange {
      width: 420px;
      height: 420px;
      background: rgba(255, 164, 9, 0.3);
      top: -140px;
      left: -120px;
    }

    &--blue {
      width: 420px;
      height: 420px;
      background: rgba(91, 148, 188, 0.28);
      bottom: -140px;
      right: -120px;
    }
  }

  &__dots {
    position: absolute;
    bottom: 8%;
    left: 5%;
    width: 120px;
    height: 120px;
    background-image: radial-gradient(rgba(91, 148, 188, 0.4) 2px, transparent 2px);
    background-size: 22px 22px;
    opacity: 0.5;
    pointer-events: none;
  }

  &__container {
    position: relative;
    z-index: 2;
    max-width: 1120px;
    margin: 0 auto;
  }

  &__head {
    text-align: center;
    margin-bottom: 56px;
  }

  &__eyebrow {
    display: inline-block;
    background: rgba(255, 164, 9, 0.14);
    color: #b06d00;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    padding: 7px 16px;
    border-radius: 999px;
    margin: 0 0 18px;
  }

  &__title {
    font-size: 38px;
    line-height: 1.2;
    font-weight: 800;
    color: #2b2b2b;
    margin: 0 0 18px;
  }

  &__bar {
    display: inline-block;
    width: 96px;
    height: 5px;
    border-radius: 999px;
    background: linear-gradient(90deg, #ffa409 0%, #5B94BC 100%);
  }

  &__intro {
    margin: 22px auto 0;
    max-width: 620px;
    font-size: 17px;
    line-height: 1.7;
    color: #ffa409;
    font-weight: 600;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
  }

  &__card {
    position: relative;
    background: #fff;
    border: 1px solid rgba(43, 43, 43, 0.06);
    border-radius: 22px;
    padding: 34px 26px 30px;
    box-shadow: 0 18px 40px rgba(43, 43, 43, 0.07);
    overflow: hidden;
    transition: transform 0.35s cubic-bezier(0.22, 0.61, 0.36, 1),
      box-shadow 0.35s ease, border-color 0.35s ease;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 5px;
      background: linear-gradient(90deg, #ffa409, #f57c00);
      opacity: 0;
      transition: opacity 0.35s ease;
    }

    &:hover {
      transform: translateY(-8px);
      border-color: rgba(255, 164, 9, 0.4);
      box-shadow: 0 28px 56px rgba(240, 136, 0, 0.16);

      &::before {
        opacity: 1;
      }
    }
  }

  &__num {
    position: absolute;
    top: 14px;
    right: 20px;
    font-size: 48px;
    font-weight: 800;
    line-height: 1;
    color: rgba(43, 43, 43, 0.07);
    user-select: none;
  }

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 62px;
    height: 62px;
    border-radius: 18px;
    margin-bottom: 22px;

    i {
      font-size: 30px;
    }

    &--1 {
      background: #fff3df;
      color: #ffa409;
    }

    &--2 {
      background: #eaf3f9;
      color: #5B94BC;
    }
  }

  &__text {
    p {
      margin: 0;
      font-size: 17px;
      font-weight: 700;
      line-height: 1.5;
      color: #2b2b2b;
    }

    p + p {
      margin-top: 2px;
      font-weight: 400;
      color: #59595b;
    }
  }
}

@media (max-width: 991px) {
  .why {
    padding: 72px 24px;

    &__grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;
    }

    &__title {
      font-size: 32px;
    }
  }
}

@media (max-width: 600px) {
  .why {
    padding: 56px 20px;

    &__grid {
      grid-template-columns: 1fr;
      gap: 16px;
    }

    &__card {
      padding: 26px 22px 24px;
      display: flex;
      align-items: center;
      gap: 18px;
    }

    &__icon {
      width: 54px;
      height: 54px;
      margin-bottom: 0;
      flex-shrink: 0;

      i {
        font-size: 26px;
      }
    }

    &__num {
      font-size: 38px;
    }
  }
}

</style>
